import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { useTheme } from 'styled-components';
import { Section } from '../../../Section';
import { ArticleCard } from '../../ArticleCard';
import { Product } from '../../Product';
import { Storefront } from '../../Storefront';
import { getLink } from '../utils';
import { Two, ProductsBlock, MainColumn } from '../partials';
import { WithRightContent } from './partials';
var ATopicSection = function ATopicSection(_ref) {
  var tag = _ref.tag,
    _ref$bottomMargin = _ref.bottomMargin,
    bottomMargin = _ref$bottomMargin === void 0 ? false : _ref$bottomMargin,
    _ref$withTitle = _ref.withTitle,
    withTitle = _ref$withTitle === void 0 ? true : _ref$withTitle;
  var theme = useTheme();
  var articles = tag.articles,
    products = tag.products,
    _tag$storefronts = tag.storefronts,
    storefronts = _tag$storefronts === void 0 ? [] : _tag$storefronts;
  var featuredArticle = articles.slice(0, 1);
  var otherArticle = articles.slice(1, 5);
  var isStorefront = !tag.tag.hasOwnProperty('window') || tag.tag.window;
  var link = getLink(theme, tag.tag);
  var title = isStorefront ? tag.tag.name : "\xDAltimos contenidos de ".concat(tag.tag.name);
  return React.createElement(Section, {
    bottomMargin: bottomMargin,
    title: withTitle ? title : null,
    link: withTitle ? link : undefined
  }, React.createElement(WithRightContent, null, React.createElement(MainColumn, null, React.createElement("div", null, featuredArticle.map(function (article, index) {
    return React.createElement(ArticleCard, {
      key: index,
      variant: "large",
      article: article,
      withImage: true
    });
  }), React.createElement("br", null)), React.createElement(Two, null, otherArticle.map(function (article, index) {
    return React.createElement(ArticleCard, {
      key: index,
      variant: "small",
      article: article,
      withImage: true
    });
  }))), React.createElement("div", null, React.createElement(ProductsBlock, {
    topMargin: true
  }, React.createElement("div", null, products.slice(0, 4).map(function (product, index) {
    return React.createElement(Product, {
      key: index,
      iconType: "manager",
      product: product
    });
  })), products.length && storefronts.length ? React.createElement("hr", null) : null, React.createElement("div", null, React.createElement("div", null, storefronts.map(function (storefront, index) {
    return React.createElement(Storefront, {
      key: index,
      storefront: storefront
    });
  })))))));
};
export default ATopicSection;